import { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import wait from 'src/utils/wait';

import {
  styled,
  Grid,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Box,
  Zoom,
  Typography,
  Divider,
  TextField,
  CircularProgress,
  Switch,
  Avatar,
  Autocomplete,
  IconButton,
  Button
} from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useSnackbar } from 'notistack';
import CloudUploadTwoToneIcon from '@mui/icons-material/CloudUploadTwoTone';
import { saveDiscount, getCustomerById, getDiscountById } from 'src/services/apiService';
import { Discount, PromotionTypeEnum } from 'src/services/apiService/response-models';

const Input = styled('input')({
  display: 'none'
});


async function fetchCustomerData(discountId, enqueueSnackbar, t, setCustomerData) {
  try {
    console.log("function called");

    const response = await getDiscountById(discountId);
    console.log(response.data);

    setCustomerData(response.data);

  } catch (ex) {
    console.error(ex);
    const msg = ex.message ? ex.message : `Failed to load customer by id`;
    enqueueSnackbar(t(msg), { variant: 'error' });
  }
}

export default function CreateCustomerDialog({ open, onClose, discountId, flag }) {
  console.log("customer dialog", discountId);

  const { t }: { t: any } = useTranslation();
  // const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [discountData, setDiscountData] = useState(null);


  const handleCreateCustomerClose = () => {
    onClose();
    // redirectToManageCustomerList();
    flag = 1;
    console.log("create ", flag);


  };

  useEffect(() => {
    if (discountId) {
      fetchCustomerData(discountId, enqueueSnackbar, t, setDiscountData);
    }

  }, [discountId, enqueueSnackbar, t]);

  const handleUpdateUser = async (values) => {
    try {
      const isPercentage = values.isPercentage;
      const discountValue = Number(values.fixedAmount);

      const payload: Discount = {
        id: values.id, // if editing an existing discount
        code: values.discountCode,
        value: {
          type: isPercentage ? PromotionTypeEnum.Percent : PromotionTypeEnum.FixedAmount,
          value: discountValue,
        },
        // minimumAmount: Number(values.minimumAmount),
        // minimumQty: Number(values.minimumQty),
        // customerGroups: values.customerGroups, // assuming this is an array of strings
        // customerTypes: values.customerTypes,   // assuming this is an array of PromotionCustomerTypeEnum
        // startDate: new Date(values.startDate),
        // endDate: new Date(values.endDate),
        // isActive: values.isActive ?? true,
        // applyOncePerCustomer: values.applyOncePerCustomer ?? false,
        // applyTimesPerCustomer: values.applyTimesPerCustomer ?? 1,
        // combineWithDiscountCodes: values.combineWithDiscountCodes ?? []
      };


      await saveDiscount({...payload , id: discountId });

      enqueueSnackbar(t('Discount updated successfully'), { variant: 'success' });
      onClose();
      flag = 1;
      console.log('create ', flag);
    } catch (err) {
      console.error(err);
      enqueueSnackbar(t('Failed to update discount'), { variant: 'error' });
    }
  };



  // const handleAddNewUser = async (values) => {
  //   try {
  //     console.log("OLD",values);
  //     // Call the saveCustomer API with the form data
  //   //   values = {
  //   //     "discountCode": "etest",
  //   //       "lastName": "mjen",
  //   //     "email": "oep@3232.ocm",
  //   //     "image": "img-1693936815610.png",
  //   //     "contactNumber": "1243445678",
  //   // }
  //     console.log("NEW",values);

  //     await saveCustomer(values);

  //     enqueueSnackbar(t('User added successfully'), { variant: 'success' });

  //     onClose();
  //   } catch (err) {
  //     console.error(err);
  //     enqueueSnackbar(t('Failed to add user'), { variant: 'error' });
  //   }
  // };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
    >
      <DialogTitle
        sx={{
          p: 3
        }}
      >
        <Typography variant="h4" gutterBottom>
          {t('Add Discount')}
        </Typography>
        <Typography variant="subtitle2">
          {t(
            'Fill in the fields below to create and edit discount code'
          )}
        </Typography>
      </DialogTitle>
      <Formik
        enableReinitialize={true}
        initialValues={{
          discountCode: discountData?.code || '',
          description: discountData?.description || '', // This will remain blank unless you add it in your backend.
          isPercentage: discountData?.value?.type === 'percent',
          fixedAmount: discountData?.value?.value || '',
          submit: null
        }}
        

        validationSchema={Yup.object().shape({
          discountCode: Yup.string()
            .max(255)
            .required(t('Discount Code field is required')),
          description: Yup.string()
            .max(255)
            .required(t('The description field is required'))
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
            await handleUpdateUser(values);
            setStatus({ success: true });
            setSubmitting(false);
          } catch (err) {
            console.error(err);
            setStatus({ success: false });
            setErrors({ submit: err.message });
            setSubmitting(false);
          }
        }}
      >

        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
          setValues // Add setValues function to update form values
        }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent
              dividers

              sx={{
                p: 4
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12} >
                  <Grid container spacing={3}>

                    <Grid item xs={12}>
                      <TextField
                        error={Boolean(
                          touched.discountCode && errors.discountCode
                        )}
                        fullWidth
                        helperText={touched.discountCode && errors.discountCode}
                        label={t('Discount Code')}
                        name="discountCode"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.discountCode}
                        variant="outlined"
                        sx={{ width: '100%' }} // Adjust width here (e.g., 90% or 600px)
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        error={Boolean(touched.description && errors.description)}
                        fullWidth
                        helperText={touched.description && errors.description}
                        label={t('Description')}
                        name="description"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.description}
                        variant="outlined"
                        sx={{ width: '100%' }}
                      />

                    </Grid>

                    <Grid item xs={12} >
                      <Box
                        display="flex"

                        alignItems="center"
                        justifyContent="flex-start"
                        flexDirection="row"
                        mt={3}
                        gap={3}
                      >
                        <Box display="flex" alignItems="center">
                          <Typography variant="body1" sx={{ mr: 2 }}>
                            Is Percentage
                          </Typography>
                          <Switch
                            checked={values.isPercentage}
                            onChange={(e) => setValues({ ...values, isPercentage: e.target.checked })}
                            name="isPercentage"
                            color="primary"
                          />
                        </Box>

                        <TextField
                          label={t('Discount Fixed Amount')}
                          name="fixedAmount"
                          fullWidth
                          type="number"
                          value={values.fixedAmount || ''}
                          onChange={handleChange}
                          variant="outlined"
                          size="small"
                          sx={{ width: '250px' }}
                          InputProps={{
                            startAdornment: !values.isPercentage ? (
                              <Typography sx={{ mr: 1 }}>$</Typography>
                            ) : null,
                            endAdornment: values.isPercentage ? (
                              <Typography sx={{ ml: 1 }}>%</Typography>
                            ) : null
                          }}
                        />

                      </Box>
                    </Grid>




                  </Grid>
                </Grid>

              </Grid>
            </DialogContent>
            <DialogActions
              sx={{
                p: 3
              }}
            >
              <Button color="secondary" onClick={handleCreateCustomerClose}>
                {t('Cancel')}
              </Button>
              <Button
                type="submit"
                startIcon={
                  isSubmitting ? <CircularProgress size="1rem" /> : null
                }
                disabled={Boolean(errors.submit) || isSubmitting}
                variant="contained"
              >
                {t('Add Discount')}
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>)
}